export const accountCols = function (translate) {
    return [ {
        field: "selector",
        title: "",
        headerTemplateURL: "headerCheckbox.html",
        type: "selection",
        show: true,
        exportable: false
    }, {
        field: "shortName",
        title: translate.instant('ACCOUNT_NAME'),
        title_key: 'ACCOUNT_NAME',
        sortable: "ACCOUNTNAME",
        show: true,
        exportable: true
    },{
        field: "accountNumber",
        title: translate.instant('ACCOUNT_NUMBER'),
        title_key: 'ACCOUNT_NUMBER',
        sortable: "ACCOUNTNUM",
        show: true,
        exportable: true
    },{
        field: "userDefinedAlias1",
        title: translate.instant('ACCOUNT_ALIAS'),
        title_key: 'ACCOUNT_ALIAS',
        sortable: "ACCOUNT_ALIAS",
        show: true,
        exportable: true
    },{
        field: "bank",
        title: translate.instant('BANK'),
        title_key: 'BANK',
        sortable: "BANK",
        show: true,
        exportable: true
    }, {
        field: "bic",
        title: translate.instant('BIC'),
        title_key: 'BIC',
        sortable: "BIC",
        show: true,
        exportable: true
    },{
        field: "countryName",
        title: translate.instant('COUNTRY'),
        title_key: 'COUNTRY',
        sortable: "COUNTRY",
        show: true,
        exportable: true
    },{
        field: "currencyCode",
        tooltip: "currencyName",
        title: translate.instant('CURRENCY'),
        title_key: 'CURRENCY',
        sortable: "CURRENCY",
        show: true,
        exportable: true
    },{
        field: "balance",
        subfield: "amount",
        title: translate.instant('BALANCE_ACC'),
        title_key: 'BALANCE_ACC',
        sortable: "BALANCE",
        show: true,
        type: "number",
        exportable: true
    },{
        field: "consolidatedBalance",
        subfield: "amount",
        title: translate.instant('BALANCE_CONS'),
        title_key: 'BALANCE_CONS',
        sortable: "CONSOLIDATED_BALANCE",
        show: true,
        type: "number",
        exportable: true
    },{
        field: "lastStatementDate",
        title: translate.instant('LAST_STATEMENT_DATE'),
        title_key: 'LAST_STATEMENT_DATE',
        sortable: "LAST_STATEMENT_DATE",
        exportable: false
    },{
        field: "",
        class: 'clearsorting-padding',
        type: "icon",
        headerTemplateURL: "sortingColumn.html",
        show: true,
        exportable: false
    }];
}
